import React, { Fragment } from "react";
import { Col, Row, Image, Button, Table } from "react-bootstrap";
import SuperAdminSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
//import SuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../../reusableComponents/allPopupReusable/NotificationButton";
import SuperAdminCall from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import CustomSuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import { ChatScreenTrack } from "./ChatScreenTrack";
import moment from "moment";
import SuperAdminSmsAdmin from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import ChatWindowMain from "../../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import { useHistory } from "react-router-dom";
import CommonNotification from "../../../../reusableComponents/allPopupReusable/CommonNotification";
//import SuperAdminSmsAdmin from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import {
  ORDER_TYPE_NAME,
  ORDER_STATUS,
  PAYMENT_TYPE,
  TRANSACTION_TYPE,
} from "../../../../../enums/OrderEnums";
import CallingIconButtonActionFile from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";
import { PAYMENT_STATUS } from "../../../../../enums/PaymentEnums";

export const ViewOpenIssuesTicketRightVendor = (props) => {
  const calcTotalPersons = (seating) => {
    var total;
    total =
      seating.adult_count +
      seating.kids_count +
      seating.high_chair +
      seating.handicap_chair;
    return total;
  };

  const history = useHistory();
  const createMemo = (id) => () => {
    history.push("/addmemo", { orderId: id });
  };

  const endTime = moment().valueOf();
  const startTime = moment(props?.logData?.itemId?.createdAt).valueOf();

  let msDifference = endTime - startTime;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function timeConvert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }
  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_right">
        <div className="open_issues_view_tickets_right_inside">
          {props?.logData?.itemType === "SEATING" && (
            <Row>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {" "}
                      {props &&
                      props.logData &&
                      props.logData.diner_id &&
                      props.logData.diner_id.adult_count ? (
                        calcTotalPersons(props.logData.diner_id)
                      ) : (
                        <> </>
                      )}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/employees.png")}
                            fluid
                            alt="Adult"
                            title="Adult"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {" "}
                          {props &&
                            props.logData &&
                            props.logData.diner_id &&
                            props.logData.diner_id.adult_count}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/children.png")}
                            fluid
                            alt="Children"
                            title="Children"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {" "}
                          {props &&
                            props.logData &&
                            props.logData.diner_id &&
                            props.logData.diner_id.kids_count}
                        </span>
                      </div>
                    </div>
                    <div className="adult-total-box-three">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/highchair.png")}
                            fluid
                            alt="Highchair"
                            title="Highchair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {props &&
                            props.logData &&
                            props.logData.diner_id &&
                            props.logData.diner_id.high_chair}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                            fluid
                            alt="Wheel Chair"
                            title="Wheel Chair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {props &&
                            props.logData &&
                            props.logData.diner_id &&
                            props.logData.diner_id.handicap_chair}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Date / Time / Timer</div>
                <div className="f11-700 text-red">00:00:00</div>
                <div className="f9-500">HH:MM:SS</div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Date & Time</div>
                <div className="f10-400">
                  {" "}
                  {moment(
                    props &&
                      props.logData &&
                      props.logData.diner_id &&
                      props.logData.diner_id.reservationTime
                  ).format("DD MMM, YYYY")}
                </div>
                <div className="f10-400">
                  {moment(
                    props &&
                      props.logData &&
                      props.logData.diner_id &&
                      props.logData.diner_id.reservationTime
                  ).format("LT")}
                </div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Seating Preference</div>
                <div className="f10-500">
                  {props?.logData?.diner_id?.seating_preference
                    ? props?.logData?.diner_id?.seating_preference[0]
                    : "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "EXP" && (
            <Row>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {props?.logData?.itemId?.adultCount ||
                        0 + props?.logData?.itemId?.kidsCount ||
                        0 + props?.logData?.itemId?.package?.adults ||
                        0 + props?.logData?.itemId?.package?.kids ||
                        0}
                    </p>

                    <div className="adult-total-box-two mr-2">
                      {props?.logData?.itemId?.adultCount +
                      props?.logData?.itemId?.package?.adults ? (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/employees.png")}
                              fluid
                              alt="Adult"
                              title="Adult"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {" "}
                            {props?.logData?.itemId?.adultCount +
                              props?.logData?.itemId?.package?.adults}
                          </span>
                        </div>
                      ) : null}

                      {props?.logData?.itemId?.kidsCount +
                      props?.logData?.itemId?.package?.kids ? (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/children.png")}
                              fluid
                              alt="Children"
                              title="Children"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {" "}
                            {props?.logData?.itemId?.kidsCount +
                              props?.logData?.itemId?.package?.kids || 0}
                          </span>
                        </div>
                      ) : null}
                    </div>
                    <div className="adult-total-box-three">
                      {props?.logData?.itemId?.highchairCount ? (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/highchair.png")}
                              fluid
                              alt="Highchair"
                              title="Highchair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.logData?.itemId?.highchairCount || 0}
                          </span>
                        </div>
                      ) : null}
                      {props?.logData?.itemId?.handicapCount ? (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                              fluid
                              alt="Wheel Chair"
                              title="Wheel Chair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {props?.logData?.itemId?.handicapCount || 0}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Date / Time / Timer</div>
                <div className="f11-700 text-red">00:00:00</div>
                <div className="f9-500">HH:MM:SS</div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Status</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.status || 0}
                </div>
              </Col>
              <Col lg={3} md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Total Wait Time</div>
                <div className="px-2" align="center">
                  <div className="enTimesLbl d-flex justify-content-center align-items-center">
                    <Image
                      src={require("../../../../../assets/images/UserManagement/hourglass.svg")}
                      alt="Edit"
                      title="Edit"
                      width="10px"
                    />
                    <p className="f10-500 text-dark pl-2">
                      {timeConvert(minutes) || "00 hh : 00 min"}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "ORDER" && (
            <Row>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 pb-3">Order Id</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.order_id || "-"}
                </div>
              </Col>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 pb-3">Date / Time / Timer</div>
                <div className="f11-700 text-red">00:00:00</div>
                <div className="f9-500">HH:MM:SS</div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Date & Time</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.laterDate
                    ? moment(props?.logData?.itemId?.laterDate).format("lll")
                    : props?.logData?.itemId?.createdAt
                    ? moment(props?.logData?.itemId?.createdAt).format("lll")
                    : ""}
                </div>
              </Col>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 mb-3">No. of Items</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.order_items?.length || 0}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Order Reference</div>
                <div className="f10-400">
                  {" "}
                  {props?.logData?.itemId.order_type === 1 ? (
                    <Fragment>
                      {props?.logData?.itemId &&
                        props?.logData?.itemId?.curb_side_details &&
                        props?.logData?.itemId?.curb_side_details.number}{" "}
                      <br />
                      {props?.logData?.itemId &&
                        props?.logData?.itemId?.curb_side_details &&
                        props?.logData?.itemId?.curb_side_details.model}{" "}
                      {props?.logData?.itemId &&
                        props?.logData?.itemId?.curb_side_details &&
                        props?.logData?.itemId?.curb_side_details.make}
                      |{" "}
                      {props?.logData?.itemId &&
                        props?.logData?.itemId?.curb_side_details &&
                        props?.logData?.itemId?.curb_side_details.color}
                    </Fragment>
                  ) : (
                    <Fragment>
                      {(props?.logData?.itemId &&
                        props?.logData?.itemId?.order_type === 3) ||
                      (props?.logData?.itemId &&
                        props?.logData?.itemId?.order_type === 2)
                        ? props?.logData?.itemId?.dine_in_details?.table_number
                        : "N/A"}
                    </Fragment>
                  )}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "OFFER" && (
            <Row>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Offer Name</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.name || "N/A"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Start Date</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.start_date
                    ? moment(props?.logData?.itemId?.start_date)
                    : "N/A"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">End Date</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.end_date
                    ? moment(props?.logData?.itemId?.end_date)
                    : "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {(props?.logData?.itemType === "SCAN" ||
            props?.logData?.itemType === "WALLET") && (
            <Row>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Transaction ID</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.transactionNumber || ""}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Amount</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.amount || "N/A"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Transaction Type</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.t_type
                    ? TRANSACTION_TYPE[props?.logData?.itemId?.t_type]
                    : "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "EVENT" && (
            <Row>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {" "}
                      {props &&
                      props.logData &&
                      props.logData.itemId &&
                      props.logData.itemId.adult_count ? (
                        calcTotalPersons(props.logData.itemId)
                      ) : (
                        <> </>
                      )}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/employees.png")}
                            fluid
                            alt="Adult"
                            title="Adult"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {" "}
                          {props &&
                            props.logData &&
                            props.logData.itemId &&
                            props.logData.itemId.adult_count}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-two-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/children.png")}
                            fluid
                            alt="Children"
                            title="Children"
                            className="icon-image"
                          />
                        </div>
                        <span className="pl-1">
                          {" "}
                          {props &&
                            props.logData &&
                            props.logData.itemId &&
                            props.logData.itemId.kids_count}
                        </span>
                      </div>
                    </div>
                    <div className="adult-total-box-three">
                      <div className="d-flex align-items-center justify-content-around mb-2">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/highchair.png")}
                            fluid
                            alt="Highchair"
                            title="Highchair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {props &&
                            props.logData &&
                            props.logData.itemId &&
                            props.logData.itemId.high_chair}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-around">
                        <div className="adult-total-box-three-insideone">
                          <Image
                            src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                            fluid
                            alt="Wheel Chair"
                            title="Wheel Chair"
                            className="icon-image-small"
                          />
                        </div>
                        <span className="pl-1">
                          {props &&
                            props.logData &&
                            props.logData.itemId &&
                            props.logData.itemId.handicap_chair}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Event Type</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_type || "N/A"}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Event Status</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_status || "N/A"}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Event Id</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_id?.event_id || "N/A"}
                </div>
              </Col>
            </Row>
          )}
          <hr />
          {props?.logData?.itemType === "SEATING" && (
            <Row>
              <Col lg={3} md={6} xs={6} className="py-3">
                <div className="f12-500 mb-3">Table / Room No.</div>
                <div className="f10-400">
                  Room No. -{" "}
                  {props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.room_number}
                </div>
                <div className="f10-400">
                  Table No. -{" "}
                  {props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.table_number}
                </div>
              </Col>
              <Col lg={3} md={6} xs={6} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f10-400">
                  {props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.occasion}
                </div>
                {/* <Button variant="link" className="text-red f12-400 p-0">
                See more
              </Button> */}
              </Col>
              <Col lg={3} md={6} xs={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="f13-400">
                  <span className="enYellowDot mr-1"></span>
                  {props &&
                    props.logData &&
                    props.logData.diner_id &&
                    props.logData.diner_id.diner_status}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "ORDER" && (
            <Row>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 pb-3">Requested Date & Time</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.createdAt
                    ? moment(props?.logData?.itemId?.createdAt).format("lll")
                    : ""}
                </div>
              </Col>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 pb-3">Order Status</div>
                <div className="f10-400">
                  {ORDER_STATUS[props?.logData?.itemId?.order_status || 0]}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Order Amount</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.total_amount || ""}
                </div>
              </Col>
              <Col md={2} xs={2} className="py-3">
                <div className="f12-500 mb-3">Payment Method</div>
                <div className="f10-400">
                  {PAYMENT_TYPE[props?.logData?.itemId?.payment_method || 0]}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 mb-3">Transaction Amount</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.transactional_id?.amount}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "OFFER" && (
            <Row>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Offer Type</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.isOnline ? "Online" : "Offline"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.coupon_code || "N/A"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Max Usage Limit</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.maximum_usage_limit || "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {(props?.logData?.itemType === "SCAN" ||
            props?.logData?.itemType === "WALLET") && (
            <Row>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.status == "captured"
                    ? "Captured"
                    : "Pending/Failed"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Payment Id</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.payment_id || "N/A"}
                </div>
              </Col>
              <Col md={4} xs={4} className="py-3">
                <div className="f12-500 pb-3">Mode</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.transaction_type || "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "EVENT" && (
            <Row>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Payment Status</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.payment_status || "N/A"}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Event Request Id</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_request_id || "N/A"}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Start Date</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_id?.start_date
                    ? moment(
                        props?.logData?.itemId?.event_id?.start_date
                      ).format("lll")
                    : "N/A"}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">End Date</div>
                <div className="f10-500">
                  {props?.logData?.itemId?.event_id?.end_date
                    ? moment(props?.logData?.itemId?.event_id?.end_date).format(
                        "lll"
                      )
                    : "N/A"}
                </div>
              </Col>
            </Row>
          )}
          {props?.logData?.itemType === "EXP" && (
            <Row>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">
                  Attended <br />
                  Date & Time
                </div>
                <div className="f10-400">
                  {" "}
                  {moment(props?.logData?.itemId?.reservationTime).format(
                    "DD MMM, YYYY"
                  )}
                </div>
                <div className="f10-400">
                  {moment(props?.logData?.itemId?.reservationTime).format("LT")}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Seat / Room No</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.seatNumber || ""}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Seating Preference</div>
                <div className="f10-400">
                  {props?.logData?.itemId?.seatingPreference?.join(", ") || ""}
                </div>
              </Col>
              <Col md={3} xs={3} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f10-400">
                  {/* {props?.logData?.itemId?.seatingPreference?.join(", ") || ""} */}
                </div>
              </Col>
            </Row>
          )}
          <hr />
          <Row>
            {props?.logData?.itemType === "ORDER" && (
              <>
                <Col lg={3} md={3} xs={3} className="py-3">
                  <div className="f12-500 mb-3">Transaction Status</div>
                  <div className="f10-400">
                    {props?.logData?.itemId?.transactional_id?.status || ""}
                  </div>
                </Col>
                <Col lg={3} md={3} xs={3} className="py-3">
                  <div className="f12-500 mb-3">Transaction Id</div>
                  <div className="f10-400">
                    {
                      props?.logData?.itemId?.transactional_id
                        ?.transactionNumber
                    }
                  </div>
                </Col>
                <Col lg={3} md={3} xs={3} className="py-3">
                  {props?.logData?.order_request_no && (
                    <div
                      className="f12-400 bg-yellow enlblSelect"
                      style={{ cursor: "pointer" }}
                      onClick={createMemo(props?.logData?.order_request_no)}
                    >
                      Create a Memo
                    </div>
                  )}
                </Col>
              </>
            )}
            {props?.logData?.itemType === "EXP" && (
              <>
                <Col md={3} xs={3} className="py-3">
                  <div className="f12-500 pb-3">Transaction ID/Amount</div>
                  <div className="f10-500">
                    {props?.logData?.itemId?.transactionDetails?.length
                      ? props?.logData?.itemId?.transactionDetails[0].txnId
                      : "N/A"}
                    {props?.logData?.itemId?.transactionDetails?.length
                      ? props?.logData?.itemId?.transactionDetails[0].amount
                      : ""}
                  </div>
                </Col>
                <Col md={3} xs={3} className="py-3">
                  <div className="f12-500 pb-3">Transaction Status</div>
                  <div className="f10-500">
                    {PAYMENT_STATUS[props?.logData?.itemId?.paymentStatus] ||
                      "N/A"}
                  </div>
                </Col>{" "}
              </>
            )}
            <Col lg={6} md={6} xs={12} className="py-3">
              <div className="d-flex flex-wrap align-items-center justify-content-end">
                {/* <SuperAdminCall /> */}
                {/* dinerInfo */}
                {/* <CallingButtonPopup
                  buttonClass="smallButton"
                  sendData={
                    props?.logData?.itemType === "SEATING" ||
                    props?.logData?.itemType === "ORDER" ||
                    props?.logData?.itemType === "SCAN" ||
                    props?.logData?.itemType === "OFFER" ||
                    props?.logData?.itemType === "TECHNICAL" ||
                    props?.logData?.itemType === "WALLET" ||
                    props?.logData?.itemType === "EVENT" ||
                    props?.logData?.itemType === "REFERRAL" ||
                    props?.logData?.itemType === "REVIEW" ||
                    props?.logData?.itemType === "GENERAL" ||
                    props?.logData?.itemType === "PAYMENT"
                      ? props?.logData
                      : props.dinerInfo
                  }
                /> */}
                <CallingIconButtonActionFile
                  orderDetails={
                    props?.logData?.itemType === "SEATING" ||
                    props?.logData?.itemType === "ORDER" ||
                    props?.logData?.itemType === "SCAN" ||
                    props?.logData?.itemType === "OFFER" ||
                    props?.logData?.itemType === "TECHNICAL" ||
                    props?.logData?.itemType === "WALLET" ||
                    props?.logData?.itemType === "EVENT" ||
                    props?.logData?.itemType === "REFERRAL" ||
                    props?.logData?.itemType === "REVIEW" ||
                    props?.logData?.itemType === "GENERAL" ||
                    props?.logData?.itemType === "PAYMENT"
                      ? props?.logData?.user_id
                      : props.dinerInfo?.user_details
                  }
                  actionType={
                    props?.logData?.itemType === "SEATING" ||
                    props?.logData?.itemType === "ORDER" ||
                    props?.logData?.itemType === "SCAN" ||
                    props?.logData?.itemType === "OFFER" ||
                    props?.logData?.itemType === "TECHNICAL" ||
                    props?.logData?.itemType === "WALLET" ||
                    props?.logData?.itemType === "EVENT" ||
                    props?.logData?.itemType === "REFERRAL" ||
                    props?.logData?.itemType === "REVIEW" ||
                    props?.logData?.itemType === "GENERAL" ||
                    props?.logData?.itemType === "PAYMENT"
                      ? "conbinedName"
                      : "orderFirstLastName"
                  }
                />
                <SendSmsButton
                  dataSend={
                    props?.logData?.itemType === "SEATING" ||
                    props?.logData?.itemType === "ORDER" ||
                    props?.logData?.itemType === "SCAN" ||
                    props?.logData?.itemType === "OFFER" ||
                    props?.logData?.itemType === "TECHNICAL" ||
                    props?.logData?.itemType === "WALLET" ||
                    props?.logData?.itemType === "EVENT" ||
                    props?.logData?.itemType === "REFERRAL" ||
                    props?.logData?.itemType === "REVIEW" ||
                    props?.logData?.itemType === "GENERAL" ||
                    props?.logData?.itemType === "PAYMENT"
                      ? props?.logData
                      : props?.dinerInfo
                  }
                  actionBy="USER_TICKET"
                  buttonClass="smallButton"
                />

                <CommonNotification
                  id={props?.logData?.ticket_number}
                  user_id={props?.logData?.user_id?._id}
                  type={4}
                  actionBy="USER_TICKET"
                />
                {/* <Button variant="link" className="enIconBtn mr-3">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/forum.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button> */}
                {props?.logData?.itemType === "SEATING" ||
                props?.logData?.itemType === "ORDER" ||
                props?.logData?.itemType === "EVENT" ? (
                  <ChatWindowMain
                    data={
                      props?.logData?.itemType === "SEATING" ||
                      props?.logData?.itemType === "ORDER" ||
                      props?.logData?.itemType === "SCAN" ||
                      props?.logData?.itemType === "OFFER" ||
                      props?.logData?.itemType === "TECHNICAL" ||
                      props?.logData?.itemType === "WALLET" ||
                      props?.logData?.itemType === "EVENT" ||
                      props?.logData?.itemType === "REFERRAL" ||
                      props?.logData?.itemType === "REVIEW" ||
                      props?.logData?.itemType === "GENERAL" ||
                      props?.logData?.itemType === "PAYMENT"
                        ? props?.logData
                        : props.dinerInfo
                    }
                    text={
                      props?.logData?.itemType === "ORDER"
                        ? "order"
                        : props?.logData?.itemType === "EVENT"
                        ? "event"
                        : "seating"
                    }
                    userTicketChatAction="USER_TICKET"
                  />
                ) : (
                  ""
                )}
                {/* <SuperAdminSMS
                  mobile_number={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id.mobile_number
                  }
                  first_name={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id.first_name
                  }
                /> */}
                {/* <SuperAdminSmsAdmin
                  mobile_number={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id.mobile_number
                  }
                  first_name={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id.first_name
                  }
                />
                <CustomSuperAdminNotification
                  _id={
                    props.logData &&
                    props.logData.user_id &&
                    props.logData.user_id._id
                  }
                /> */}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="open_issues_view_tickets_right mt-2">
        <div className="px-4 py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center f12-500">
              {props.showChat && (
                <i
                  className="fa fa-long-arrow-left mr-3 cursor-pointer"
                  aria-hidden="true"
                  onClick={props.onClickShowLog}
                ></i>
              )}
              Resolution Log
            </div>
            {/* <NavLink
              to=""
              onClick={() => alert("Sd")}
              className="f12-500 text-blue"
            >
              View all
            </NavLink> */}
            {props.showLog ? (
              <span
                onClick={() => props.handleChatSHow()}
                className="f12-500 text-blue cursor"
              >
                View all
              </span>
            ) : (
              <> </>
            )}
          </div>
        </div>

        {props.showLog && (
          <Table className="w-100 enResolutionLogTBL">
            <thead>
              <tr>
                <th style={{ width: "20%" }} className="pl-4">
                  <div className="f10-500">Date</div>
                </th>
                <th style={{ width: "60%" }}>
                  <div className="f10-500">Comments</div>
                </th>
                <th style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-500">Comments By</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {logData.ticketLogs.map((log,index)=>())} */}

              {props.logData &&
                props.logData.ticketLogs &&
                props.logData.ticketLogs.map((log, index) => (
                  <tr key={index}>
                    <td style={{ width: "20%" }} className="pl-4">
                      <div className="f10-400">
                        {" "}
                        {moment(log.time).format("MMMM Do YYYY")}
                      </div>
                      <div className="f10-500">
                        {moment(log.time).format("LT")}
                      </div>
                    </td>
                    <td style={{ width: "60%" }}>
                      <div className="f10-400">{log.content}</div>
                    </td>
                    <td style={{ width: "20%" }} className="pr-4 text-center">
                      <div className="f10-400">You</div>
                    </td>
                  </tr>
                ))}
              {/* <tr>
                <td style={{ width: "20%" }} className="pl-4">
                  <div className="f10-400">13th August, 2019</div>
                  <div className="f10-500">06:30 PM</div>
                </td>
                <td style={{ width: "60%" }}>
                  <div className="f10-400">
                    Seating status changed from not seated to seated
                  </div>
                </td>
                <td style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-400">User</div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "20%" }} className="pl-4">
                  <div className="f10-400">13th August, 2019</div>
                  <div className="f10-500">06:30 PM</div>
                </td>
                <td style={{ width: "60%" }}>
                  <div className="f10-400">
                    Seating status changed from not seated to seated
                  </div>
                </td>
                <td style={{ width: "20%" }} className="pr-4 text-center">
                  <div className="f10-400">You</div>
                </td>
              </tr> */}
            </tbody>
          </Table>
        )}

        {props.showChat && (
          <React.Fragment>
            <div className="col-12 open_issues_view_tickets_chat_screen">
              <div className="display-chat-screen-one">
                <div>
                  <h3>
                    {props && props.logData && props.logData.seating_request_no}
                  </h3>
                  <p className="bottom-text color-gray">Request Number</p>
                </div>
              </div>
              <div className="col-12 open_issues_view_tickets_chat_screen">
                <div className="chat-screen-max-height" id="style-4">
                  <ChatScreenTrack
                    comment={props && props.logData && props.logData.comment}
                    auth={props && props.auth}
                  />
                </div>
              </div>
            </div>
            <div className="chat-submit-button">
              <div>
                <div className="input-group button-chat-box">
                  <input
                    type="text"
                    className="form-control input-box-height"
                    placeholder="Write your comment"
                    aria-label="Write your comment"
                    aria-describedby="button-addon2"
                    value={props.message}
                    onChange={(e) => props.setMessage(e.target.value)}
                  />
                  <div className="input-group-append chat-button-box">
                    <div className="enChatFileUploadBtn">
                      <input type="file" />
                      <Image
                        fluid
                        alt="Back Icon"
                        title="Back Icon"
                        className="mr-2"
                        src={require("../../../../../assets/images/UserManagement/paper-clip.svg")}
                      />
                    </div>
                    <button
                      className="chat-button-box-button"
                      type="button"
                      id="button-addon2"
                      onClick={props.onClickAddComment}
                    >
                      <i
                        className="font-awesome-flag-size fa fa-paper-plane-o"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};
